import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { c as classNamePropTypes } from './classNames-cc2dcbf1.js';
import { m as marginPropTypes } from './spacing-7e57ffb0.js';
import { S as SvgIcon } from './SvgIcon-1308e965.js';

function IconDatabase(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2.667 5.018V8c0 .542 2.371 1.333 5.333 1.333S13.333 8.542 13.333 8V5.018C12.116 5.65 10.18 6 8 6s-4.117-.349-5.333-.982zM1.333 3.333C1.333 1.662 4.319.666 8 .666s6.667.996 6.667 2.667v9.333c0 1.675-2.972 2.667-6.667 2.667s-6.667-.992-6.667-2.667zm12 6.356c-1.214.63-3.147.978-5.333.978s-4.119-.347-5.333-.978v2.978C2.667 13.209 5.038 14 8 14s5.333-.791 5.333-1.333zM8 4.667c2.947 0 5.333-.795 5.333-1.333S10.947 2.001 8 2.001s-5.333.795-5.333 1.333S5.053 4.667 8 4.667z"
  }));
}
IconDatabase.propTypes = {
  /** size of icon */
  size: PropTypes.oneOf(['sm', 'smd', 'md', 'mlg', 'lg', 'none']),
  /** CSS class to use, if any */
  className: classNamePropTypes,
  /** color, if not inheriting from parent's text color */
  color: PropTypes.oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white']),
  /** margin for icon, if any */
  margin: marginPropTypes
};
IconDatabase.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null
};

export { IconDatabase as default };
